import { Injectable } from '@angular/core';
import { Observable ,  BehaviorSubject } from 'rxjs';
import { WebSocketService } from './websocket.service';


@Injectable()
export class WifiStatusService 
{
    offline = false;
    // Holds the current Socket Status 
    public wifiStatusSubject$ = new BehaviorSubject<any>(false);

    constructor(private webSocketService: WebSocketService)
    {
        // console.log(window);
        // ----------------------------------------------
        // Monitor Your Network’s Status 
        // ----------------------------------------------
        window.addEventListener('online',  this.onNetworkStatusChange.bind(this));
        window.addEventListener('offline', this.onNetworkStatusChange.bind(this));          
    }


    onNetworkStatusChange()
    {
        this.offline = !navigator.onLine;

        // console.log('offline ' + this.offline);    
        this.wifiStatusSubject$.next(this.offline);
    }

    isNetworkOnline()
    {
        // console.log(this.wifiStatusSubject$.getValue());
        return this.wifiStatusSubject$.getValue();
    }
    
}
